export const cilBoatAlt = ["24 24","<path d='M20.4 11.625l-1.141-3.138c-0.217-0.58-0.766-0.986-1.41-0.987h-1.84l-0.75-4.5h-4.896l0.75 4.5h-1.854l-0.75-4.5h-4.896l0.75 4.5h-2.115v4.125h-1.5v9.375h20.050l2.45-7.759v-1.616zM12.135 4.5h1.854l0.5 3h-1.854zM5.385 4.5h1.854l0.5 3h-1.854zM3.75 9h14.1l0.955 2.625h-15.054zM19.7 19.5h-17.45v-6.375h19.464z'></path><path d='M3.75 15h1.5v1.5h-1.5v-1.5z'></path><path d='M6.75 15h1.5v1.5h-1.5v-1.5z'></path><path d='M9.75 15h1.5v1.5h-1.5v-1.5z'></path><path d='M12.75 15h1.5v1.5h-1.5v-1.5z'></path><path d='M15.75 15h1.5v1.5h-1.5v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-boat-alt.js
// module id = null
// module chunks = 